module.exports = import("https://unpkg.com/docx@8.2.4/build/index.mjs");;